// This component has been added ad-hoc by sales-leader-insights-fe team: https://private.hubteam.com/janus/groups/hs-sales-leader-insights-fe
// For any questions/concerns, please use Slack channel: #sales-leader-insights-fe

import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { Popover } from 'foundations-components/transitional/components/Popover';
import getTranscriptSettingsUrl from '../../utils/getTranscriptSettingsUrl';
import { jsx as _jsx } from "react/jsx-runtime";
const TranscriptSettingShepherd = ({
  isTranscriptionAdmin,
  showShepherd,
  onClose,
  onClickGoToSettings,
  children
}) => {
  const adminShepherdContent = {
    header: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "transcriptQuickFilter.transcriptSettingShepherd.adminPopover.header"
    }),
    body: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "transcriptQuickFilter.transcriptSettingShepherd.adminPopover.body"
    }),
    footer: /*#__PURE__*/_jsx(Button, {
      href: getTranscriptSettingsUrl(),
      onClick: onClickGoToSettings,
      use: "primary",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "transcriptQuickFilter.transcriptSettingShepherd.adminPopover.cta"
      })
    })
  };
  const nonAdminShepherdContent = {
    header: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "transcriptQuickFilter.transcriptSettingShepherd.nonAdminPopover.header"
    }),
    body: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "transcriptQuickFilter.transcriptSettingShepherd.nonAdminPopover.body"
    }),
    footer: /*#__PURE__*/_jsx(Button, {
      onClick: onClose,
      use: "primary",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "transcriptQuickFilter.transcriptSettingShepherd.nonAdminPopover.cta"
      })
    })
  };
  const shepherdContent = isTranscriptionAdmin ? adminShepherdContent : nonAdminShepherdContent;
  return /*#__PURE__*/_jsx(Popover, {
    use: "shepherd",
    inlineSize: "375px",
    showCloseButton: true,
    closeOnOutsideClick: false,
    placement: "bottom",
    open: showShepherd,
    onOpenChange: onClose,
    content: shepherdContent,
    children: children
  });
};
export default TranscriptSettingShepherd;